import { RootState } from '@/store/stores'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import hydraulicDataConfig from '@/api/config/hydraulicDataConfig'
import { HydraulicType, SearchHydraulic } from '@/types/hydraulic'
// import { WeatherReportParams } from '@/types/weather'

import { initialState } from '@store/types/interfaceCommonDataType'

export const fetchPipeData = createAsyncThunk(
  'interfaceCommonData/fetchPipeData',
  async (params: SearchHydraulic, { rejectWithValue }) => {
    try {
      const { data } = await hydraulicDataConfig.getAll(params)

      return {
        interfaceId: params.interfaceId,
        hydraulicData: data.data as HydraulicType[],
      }
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

export const interfaceCommonDataSlice = createSlice({
  name: 'interfaceCommonData',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // fetchPipeData
      .addCase(fetchPipeData.fulfilled, (state, action) => {
        if (action.payload.hydraulicData && action.payload.interfaceId) {
          state.hydraulicData[`${action.payload.interfaceId}`] =
            action.payload.hydraulicData
        }
      })
  },
})

export const interfaceCommonDataState = (state: RootState) =>
  state.interfaceCommonData

export default interfaceCommonDataSlice.reducer
